module.exports = __webpack_public_path__ + "assets/img/5_1276.29b9b83b.jpg";